"use client";

import { motion, useReducedMotion } from "framer-motion";
import { useEffect, useState } from "react";

const words = ["ideas?", "goals?", "curiosity?"];

export default function AnimatedFooterWord() {
	const shouldReduceMotion = useReducedMotion();
	const [wordIndex, setWordIndex] = useState(0);
	const [displayedText, setDisplayedText] = useState(words[0]);
	const [isDeleting, setIsDeleting] = useState(false);

	useEffect(() => {
		if (shouldReduceMotion) {
			setDisplayedText(words[0]);
			return;
		}

		const currentWord = words[wordIndex];
		const isWordComplete = displayedText === currentWord;
		const isWordCleared = displayedText.length === 0;

		const timeout = window.setTimeout(
			() => {
				if (!isDeleting && isWordComplete) {
					setIsDeleting(true);
					return;
				}

				if (isDeleting && isWordCleared) {
					setIsDeleting(false);
					setWordIndex((currentIndex) => (currentIndex + 1) % words.length);
					return;
				}

				setDisplayedText((currentText) => {
					if (isDeleting) return currentText.slice(0, -1);

					return currentWord.slice(0, currentText.length + 1);
				});
			},
			isWordComplete && !isDeleting ? 1300 : isDeleting ? 46 : 82,
		);

		return () => window.clearTimeout(timeout);
	}, [displayedText, isDeleting, shouldReduceMotion, wordIndex]);

	return (
		<span
			className="inline-flex min-w-[6em] items-baseline whitespace-nowrap align-baseline leading-none text-zinc-300"
			aria-label={displayedText}
			style={{ font: "inherit" }}
		>
			<span className="leading-none" aria-hidden="true">
				{displayedText || "\u200b"}
			</span>
			{shouldReduceMotion ? null : (
				<motion.span
					aria-hidden="true"
					className="ml-1 inline-block h-[0.82em] w-px bg-zinc-300"
					animate={{ opacity: [1, 0, 1] }}
					transition={{ duration: 0.9, repeat: Infinity, ease: "linear" }}
				/>
			)}
		</span>
	);
}
